import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import elementTw from 'element-ui/lib/locale/lang/zh-TW'
import elementEn from 'element-ui/lib/locale/lang/en'
import zh from './zh'
import zhTW from './zh-TW'
import en from './en'

Vue.use(VueI18n)

const messages = {
  'zh-CN': { ...zh, ...elementZh },
  'zh-TW': { ...zhTW, ...elementTw },
  'en': { ...en, ...elementEn }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('LANG') || 'en',
  messages
})

export default i18n